import React from 'react'
import { Box, Button, SvgIcon, Typography } from '@mui/material'
import { EmptyStateContainer } from './EmptyState.styled'

type EmptyStateProps = {
  icon: React.ElementType
  title: string
  description: string
  buttonText?: string
  endIcon?: React.ElementType
  onButtonClick?: () => void
}

export const EmptyState = ({
  icon,
  title,
  description,
  buttonText,
  endIcon,
  onButtonClick,
}: EmptyStateProps) => (
  <EmptyStateContainer>
    <Box mr={2}>
      <SvgIcon component={icon} fontSize='large' color='action' />
    </Box>
    <Box flexGrow={1}>
      <Typography variant='h6'>{title}</Typography>
      <Typography variant='body2' color='textSecondary'>
        {description}
      </Typography>
    </Box>
    {buttonText && onButtonClick && (
      <Box ml={2}>
        <Button
          variant='contained'
          color='primary'
          onClick={onButtonClick}
          endIcon={endIcon ? <SvgIcon component={endIcon} /> : undefined}
        >
          {buttonText}
        </Button>
      </Box>
    )}
  </EmptyStateContainer>
)
